function TrashFilled({ width = 13, height = 14, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox='0 0 13 14' fill='none' {...props}>
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M4.77105 1.43131C4.6393 1.43131 4.5325 1.53812 4.5325 1.66987V2.62408H7.87223V1.66987C7.87223 1.53812 7.76542 1.43131 7.63368 1.43131H4.77105ZM0.715657 2.62408H3.10118V1.66987C3.10118 0.747625 3.8488 0 4.77105 0H7.63368C8.55592 0 9.30354 0.747625 9.30354 1.66987V2.62408H11.6891C12.0843 2.62408 12.4047 2.94449 12.4047 3.33973C12.4047 3.73498 12.0843 4.05539 11.6891 4.05539H11.3485L10.014 12.9526C9.97893 13.1861 9.77826 13.3589 9.54209 13.3589H2.86263C2.62647 13.3589 2.42584 13.1861 2.39081 12.9526L1.05622 4.05539H0.715657C0.32041 4.05539 0 3.73498 0 3.33973C0 2.94449 0.32041 2.62408 0.715657 2.62408Z'
        fill='currentColor'
        fill-opacity='0.5'
      />
    </svg>
  );
}

export default TrashFilled;
